import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {price ,priceResponse} from '../../services/api/api'
// Models
interface iPrices {
  [key: number]: price[];
}
export interface productsState {
  isLoaded: boolean; // First load
  isLoading: boolean; // On filtering laoder
  isFetching: boolean;
  hasMore: boolean;
  showPrice: boolean;
  prices: iPrices;
  price?: price;
  page: number;
}

const initialProductsState: productsState = {
  isLoaded: false,
  isLoading: false,
  isFetching: false,
  hasMore: true,
  showPrice: false,
  prices: {},
  page: 1,
};

// Products slice
export const productsSlice = createSlice({
  name: 'products',
  initialState: initialProductsState,
  reducers: {
    setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoaded = payload;
    },
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
      state.isFetching = payload;
    },
    setHasMore: (state, { payload }: PayloadAction<boolean>) => {
      state.hasMore = payload;
    },
    setShowPrice: (state, { payload }: PayloadAction<boolean>) => {
      state.showPrice = payload;
    },

    setPrice: (state, { payload }: PayloadAction<price | undefined>) => {
      state.price = payload;
    },
    initializePrices: (state, { payload }: PayloadAction<price[]>) => {
      state.prices[state.page] = payload;
    },
    addPrices: (state, { payload }: PayloadAction<price[]>) => {
      state.prices[state.page] = state.prices[state.page]
        ? [...state.prices[state.page], ...payload]
        : payload;
    },
    updateprice: (state, { payload }: PayloadAction<priceResponse>) => {

      let index = state.prices[state.page].findIndex(
        (price) => price.id === payload.pid,
      );
    
      if (index !== -1) {

         if ( state.prices[state.page][index].id = payload.pid){
          state.prices[state.page][index].price=payload.price
         }
        
      }
    },
    deleteprices: (state, { payload }: PayloadAction<number[]>) => {
      payload.map((id) => {
        let index = state.prices[state.page].findIndex(
          (price) => price.id === id,
        );
        if (index != -1) {
          state.prices[state.page].splice(index, 1);
          if (state.price?.id === id) state.price = undefined;
        }
      });
    },
    reset: (state) => {
      state.prices = [];
      state.hasMore = true;
    },
    setPage: (state, { payload }: PayloadAction<number>) => {
      state.page = payload;
    },
  },
});
